import Vue from 'vue';
import vueDebounce from 'vue-debounce';

import JobPage from './components/JobPage.vue';
import JobForm from './components/JobForm.vue';
import ToolList from './components/ToolList.vue';
import './assets/css/tailwind.css';

Vue.config.productionTip = false;
Vue.use(vueDebounce, {
  defaultTime: '200ms',
});

export const routes = {
  '/': JobPage,
  '/tools': ToolList,
  '/new-job': JobForm,
};

new Vue({
  el: '#app',
  data: {
    currentRoute: window.location.pathname,
  },
  computed: {
    ViewComponent() {
      return routes[this.currentRoute];
    },
  },
  render(h) {
    return h(this.ViewComponent);
  },
  /* eslint-disable no-debugger */
});
